import gql from 'graphql-tag'

export const UPDATE_PROPERTY_ROOM_REPRESENTATIVE_USER_MUTATION = gql`
  mutation UpdatePropertyRoomRepresentativeUser (
    $userId: Int!
    $email: String
    $firstName: String!
    $lastName: String!
    $firstNameKana: String
    $lastNameKana: String
    $isActive: Boolean!
    $telNumber: String!
    $icCardIds: [String!]
    $familyMembers: [AdminUpdateFamilyMemberInput!]
  ) {
    updatePropertyRoomRepresentativeUser(
      data: {
        id: $userId
        email: $email
        firstName: $firstName
        lastName: $lastName
        firstNameKana: $firstNameKana
        lastNameKana: $lastNameKana
        isActive: $isActive
        telNumber: $telNumber
        familyMembers: $familyMembers
      }
      roomInfo: {
        icCardIds: $icCardIds
      }
    ){
      id
    }
  }
`
